// Turks (tr-TR), hallway: het bord in de gang van een gedeelde woning (golf 6b).
export const hallwayTr = {
    thisWeek: 'Bu hafta sıra kimde',
    today: 'Bugün',
    cooks: 'Yemeği {name} yapıyor',
    nobody: 'Kimse',
    done: 'Yapıldı',
    doneBy: 'Yapan: {name}',
    tapHint: 'Bir iş bitince üzerine dokun',
    whoDid: '{duty} işini kim yaptı?',
    saved: '{duty}: yapan {name}',
    undo: 'Hata, geri al',
    undone: 'Geri alındı',
    agenda: 'Ev takvimi',
    nothingPlanned: 'Planlanan bir şey yok',
    close: 'Kapat',
    allDone: 'Bu hafta her şey yapıldı',
    noDuties: 'Henüz çizelge yok. Uygulamada Nöbet çizelgesi bölümünden oluştur.',
};
//# sourceMappingURL=hallway.tr.js.map